module.exports = __webpack_public_path__ + "static/media/Allergies-Form.17c0f882.pdf";